// extracted by css-extract-rspack-plugin
var _1 = "ez";
export { _1 as "imageLoaderComponent" }
